var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.84167 11.5757L5.83333 19.1673L10 16.6673L14.1667 19.1673L13.1583 11.5673M15.8333 6.66732C15.8333 9.88898 13.2217 12.5007 10 12.5007C6.77834 12.5007 4.16667 9.88898 4.16667 6.66732C4.16667 3.44566 6.77834 0.833984 10 0.833984C13.2217 0.833984 15.8333 3.44566 15.8333 6.66732Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/Award.9786907d0efbcd9576c6102d4b55b0b1.svg";
export { ForwardRef as ReactComponent };